import styled from 'styled-components'

import barra from '../../images/barra.svg'
import barraMobile from '../../images/barra-mobile.svg'

export const BarWrapper = styled.div`
  max-width: 1088px;
  height: 4px;
  margin: 0 auto 112px;

  background-image: url(${barra});

  @media (max-width: 767px) {
    margin: 0 24px 60px;
    background-image: url(${barraMobile});
  }
`
